export default "__VITE_ASSET__8932a058__"